import { useEffect, useState } from "react";
function safeParse(input) {
  try {
    return JSON.parse(input);
  } catch (ex) {
    return void 0;
  }
}
const fetchBodyElement = () => document.body;
const useTrackClickEvents = (trackEvent, fetchContainerElement = fetchBodyElement) => {
  const [previousEvent, setPreviousEvent] = useState({
    previousEventId: "",
    previousTime: {}
  });
  useEffect(() => {
    function onClick(ev) {
      if (!(ev.target instanceof Element))
        return;
      if (ev.target.closest("body") && !fetchContainerElement()?.contains(ev.target)) {
        return;
      }
      const target = ev.target.closest("[data-analytics-id]");
      const { analyticsId, analyticsAttributes } = target?.dataset || {};
      if (!analyticsId)
        return;
      const { previousEventId, previousTime } = previousEvent;
      if (analyticsId === previousEventId && Date.now() - previousTime.getTime() < 500) {
        setPreviousEvent({
          previousEventId: analyticsId,
          previousTime: new Date()
        });
        return;
      }
      setPreviousEvent({
        previousEventId: analyticsId,
        previousTime: new Date()
      });
      trackEvent(`Clicked - ${analyticsId}`, analyticsAttributes ? safeParse(analyticsAttributes) : void 0);
    }
    document.addEventListener("click", onClick, false);
    return () => {
      document.removeEventListener("click", onClick);
    };
  }, [fetchContainerElement, previousEvent, setPreviousEvent, trackEvent]);
};
export default useTrackClickEvents;
